'use strict';

/**
 * files-bulk-delete — pure request builder for the Files bulk delete action
 * (files.js's removeSelected confirm handler, ~line 201-230).
 *
 * Extracted so the DELETE request shape can be tested directly without
 * instantiating the Angular controller (this repo's convention for
 * controllers wired up via `.component(...)` — see display-bulk-clear.js /
 * group-bulk-assign.js).
 */
function buildBulkDeleteRequest(slsUri, accountId, selectedFiles) {
    var ids = (selectedFiles || []).map(function (file) {
        return file.id;
    });

    return {
        method: 'DELETE',
        url: slsUri + '/files/delete-bulk',
        data: {
            accountId: accountId,
            ids: ids,
        },
    };
}

var filesBulkDelete = {
    buildBulkDeleteRequest: buildBulkDeleteRequest,
};

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = filesBulkDelete;
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('filesBulkDelete', filesBulkDelete);
}
